const menuStructure = [];

export default menuStructure;
